import { X } from "lucide-react";
import { useState } from "react";

import { Tooltip, TooltipContent, TooltipTrigger } from "@design-lab/shared/ui/tooltip";
import { ExampleIllustration } from "./ExampleIllustration";
import { ExampleOutput } from "./ExampleOutput";
import { QuestionMarkIcon } from "./icons";

export function HelpTooltip() {
  const [isHelpOpen, setIsHelpOpen] = useState(false);

  return (
    <Tooltip open={isHelpOpen}>
      <TooltipTrigger asChild data-testid="need-help-trigger" onClick={() => setIsHelpOpen(true)}>
        <button
          className="leading-4.5 flex items-center gap-1 align-middle text-xs font-normal text-gray-500 underline hover:text-gray-600"
          data-testid="need-help-trigger-button"
        >
          Need help
          <QuestionMarkIcon className="size-4.5" />
        </button>
      </TooltipTrigger>
      <TooltipContent
        side="right"
        className="relative max-w-lg border border-gray-200 bg-white p-4 shadow-lg"
        arrowClassName="bg-white fill-white border-gray-200"
      >
        <div className="w-96">
          <div className="mb-3 flex items-start justify-between gap-4">
            <h3 className="leading-7.5 text-xl font-semibold text-gray-900">Example Prompt</h3>
            <button
              type="button"
              aria-label="Close help"
              className="rounded p-1 text-blue-700 hover:bg-gray-100 hover:text-blue-800"
              onClick={() => setIsHelpOpen(false)}
              data-testid="close-help-button"
            >
              <X className="size-6" />
            </button>
          </div>

          {/* Style/Subject tabs */}
          <ExampleIllustration />

          {/* Example Output */}
          <ExampleOutput />
        </div>
      </TooltipContent>
    </Tooltip>
  );
}
